const hasTimezoneSuffix = /(Z|[+-]\d{2}:?\d{2})$/;

export default function parseUtcDate(date: string): Date {
  return new Date(hasTimezoneSuffix.test(date) ? date : date + 'Z');
}
